// extracted by css-extract-rspack-plugin
export default {"countryDetailsWrapper":"VerificationOrganisationDetails_countryDetailsWrapper__H70lX"};